const DIAGNOSES = [
  { value: 1, label: 'Hauptdiagnose' },
  { value: 2, label: '1. Nebendiagnose' },
  { value: 3, label: '2. Nebendiagnose' },
  { value: null, label: 'Keine Angabe' },
];

export default [
  {
    type: 'section',
    label: 'Zur Abklärungsstelle',
    heading: 'Zur Abklärungsstelle / zur fallführenden Person',
    stub: true,
    children: [
      {
        type: 'group',
        children: [
          {
            id: 'bfdcfc5b-6f71-4987-8d5a-834e12b2dc98',
            type: 'input',
            component: 'select',
            for_state: false,
            for_report: true,
            required: false,
            stub: true,
            props: {
              label: 'Abklärungsstelle',
              optionsFunc: 'getBranches',
            },
          },
          {
            id: '9c9afd9b-7a31-4c81-a236-aac8f1d543dc',
            type: 'input',
            component: 'select',
            for_state: false,
            for_report: true,
            required: true,
            stub: true,
            props: {
              label: 'Fallführende Person',
              optionsFunc: 'getPsychologists',
              valueFunc: 'getUserUuid',
            },
          },
          {
            id: '0a23f050-2f71-45f7-83a2-cf9ac8b64c1c',
            type: 'input',
            component: 'datepicker',
            for_state: true,
            for_report: false,
            required: true,
            stub: true,
            props: {
              label: 'Eröffnungsdatum SAV',
              valueFunc: 'getCurrentDate',
            },
          },
        ],
      },
    ],
  },
  {
    type: 'section',
    label: 'Zum Kind / Jugendlichen',
    heading: 'Angaben zum Kind / Jugendlichen',
    stub: true,
    children: [
      {
        type: 'group',
        children: [
          {
            id: '973834ac-3158-46be-8285-820d6545ac99',
            type: 'input',
            component: 'textinput',
            for_state: false,
            for_report: true,
            required: true,
            stub: true,
            props: {
              label: 'Name',
              value: 'k.A.',
            },
          },
          {
            id: '9490f6ea-220b-4d71-86b5-b6129887d008',
            type: 'input',
            component: 'textinput',
            for_state: false,
            for_report: true,
            required: true,
            stub: true,
            props: {
              label: 'Vorname',
              value: 'k.A.',
            },
          },
          {
            id: 'bad095ff-8f27-4e42-9041-b4f2d9474f9e',
            type: 'input',
            component: 'datepicker',
            for_state: true,
            for_report: true,
            required: false,
            stub: true,
            props: {
              label: 'Geburtsdatum',
              tooltip: 'Hinweis: An den Kanton geht nur der Jahrgang',
            },
          },
          {
            id: '510550f2-e07d-4866-bb4d-511c4563e023',
            type: 'input',
            component: 'select',
            for_state: true,
            for_report: true,
            required: true,
            stub: true,
            props: {
              label: 'Geschlecht',
              options: [
                { value: 'm', label: 'Männlich' },
                { value: 'w', label: 'Weiblich' },
                { value: 'x', label: 'Divers' },
              ],
            },
          },
          {
            id: 'f026fb29-a17b-4192-be82-4e44acebae59',
            type: 'input',
            component: 'textinput',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Lebensalter am Startdatum der Basisabklärung (x Jahre, x Monate)',
            },
          },
          {
            id: '96948104-b2b4-4afc-9e36-b2509bfa47d8',
            type: 'input',
            component: 'checkbox-group',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              label: 'Erstsprache(n)',
              tooltip: 'Erstsprache(n), genaue Bezeichnung (evt. Dialekt). Es können auch mehrere Sprachen als Erstsprache des Kindes/Jugendlichen angegeben werden. Die Sprachsituation der Familie bei Mehrsprachigkeit beschreiben im Abschnitt Familiärer Kontext -> Lebens- und Betreuungssituation oder (früh)kindliche Entwicklung.',
              classes: ['three-columns'],
              value: [],
              options: [
                { value: 'deu', label: 'Deutsch' },
                { value: 'fra', label: 'Französisch' },
                { value: 'ita', label: 'Italienisch' },
                { value: 'esp', label: 'Spanische Sprachen' },
                { value: 'por', label: 'Portugiesisch' },
                { value: 'tur', label: 'Türkisch' },
                { value: 'eng', label: 'Englisch' },
                { value: 'alb', label: 'Albanisch' },
                { value: 'west-eur', label: 'Übrige westeurop. Sprachen' },
                { value: 'nord-eur', label: 'Übrige nordeurop. Sprachen' },
                { value: 'slav', label: 'Übrige slawische Sprachen' },
                { value: 'kro', label: 'Kroatisch' },
                { value: 'srb', label: 'Serbisch' },
                { value: 'bos', label: 'Bosnisch' },
                { value: 'east-eur', label: 'Übrige osteuropäische Sprachen' },
                { value: 'eur', label: 'Übrige europäische Sprachen' },
                { value: 'west-asia', label: 'Übrige westasiatische Sprachen' },
                { value: 'tam', label: 'Tamil' },
                { value: 'indo', label: 'Übrige indoarische und drawidische Sprachen' },
                { value: 'east-asia', label: 'Übrige ostasiatische Sprachen' },
                { value: 'arab', label: 'Arabisch' },
                { value: 'afr', label: 'Übrige afrikanische Sprachen' },
                { value: 'other', label: 'Übrige Sprachen' },
              ],
            },
          },
          {
            id: '30738a09-0e86-4d53-9d96-b52179de1196',
            type: 'input',
            component: 'checkbox-group',
            for_state: false,
            for_report: false,
            required: false,
            props: {
              label: 'Weitere Sprache(n)',
              tooltip: 'Weitere Sprachen, die das Kind bzw. der oder die Jugendliche im Alltag spricht, die aber nicht einer Erstsprache ensprechen.',
              classes: ['three-columns'],
              value: [],
              options: [
                { value: 'deu', label: 'Deutsch' },
                { value: 'fra', label: 'Französisch' },
                { value: 'ita', label: 'Italienisch' },
                { value: 'esp', label: 'Spanische Sprachen' },
                { value: 'por', label: 'Portugiesisch' },
                { value: 'tur', label: 'Türkisch' },
                { value: 'eng', label: 'Englisch' },
                { value: 'alb', label: 'Albanisch' },
                { value: 'west-eur', label: 'Übrige westeurop. Sprachen' },
                { value: 'nord-eur', label: 'Übrige nordeurop. Sprachen' },
                { value: 'slav', label: 'Übrige slawische Sprachen' },
                { value: 'kro', label: 'Kroatisch' },
                { value: 'srb', label: 'Serbisch' },
                { value: 'bos', label: 'Bosnisch' },
                { value: 'east-eur', label: 'Übrige osteuropäische Sprachen' },
                { value: 'eur', label: 'Übrige europäische Sprachen' },
                { value: 'west-asia', label: 'Übrige westasiatische Sprachen' },
                { value: 'tam', label: 'Tamil' },
                { value: 'indo', label: 'Übrige indoarische und drawidische Sprachen  ' },
                { value: 'east-asia', label: 'Übrige ostasiatische Sprachen' },
                { value: 'arab', label: 'Arabisch' },
                { value: 'afr', label: 'Übrige afrikanische Sprachen' },
                { value: 'other', label: 'Übrige Sprachen' },
              ],
            },
          },
          {
            id: '561e6cc3-1347-41e3-a67f-a6c2438c3413',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Eltern / Erziehungsberechtigte: Name, Vorname (Adresse, Telefon)',
              tooltip: 'Adresse der Eltern',
            },
          },
          {
            id: 'd0545308-193f-4ab1-af8d-eb319b2869d4',
            type: 'input',
            component: 'textinput',
            for_state: true,
            for_report: false,
            required: true,
            props: {
              label: 'Postleitzahl (zuständige Schulgemeinde des Kindes)',
              tooltip: 'Hinweis: An den Kanton geht nur der Bezirk',
            },
          },
          {
            id: '9052eb2f-2516-4423-94c8-57ae3bc1f4e3',
            type: 'input',
            component: 'textinput',
            for_state: false,
            for_report: false,
            required: false,
            props: {
              label: 'AHV-Nummer',
              placeholder: '756.1234.5678.90',
              mask: 'nnn.nnnn.nnnn.nn',
            },
          },
          {
            id: '475eb077-e6b1-4bb7-8b36-16b5df4c0c80',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Besondere Erziehungsverantwortung',
              tooltip: 'Wenn keine Besonderheiten ein „-". Nach Scheidung gemeinsame oder alleinige elterliche Sorge festhalten. Bei Beistandschaft (mit schulischen Aufgaben gemäss Verfügung KESB) Name und Funktion, allenfalls nur Funktion.',
            },
          },
          {
            id: '57e3f7f4-670b-4893-9edf-8767f69cf3cc',
            type: 'input',
            component: 'select',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              label: 'Form der Schulung',
              options: [
                { value: 1, label: 'Regelklasse' },
                { value: 2, label: 'integrierte Sonderschulung' },
                { value: 3, label: 'Einzelunterricht' },
                { value: 4, label: 'Tagessonderschule' },
                { value: 5, label: 'Heimsonderschule' },
                { value: 6, label: 'besondere Klasse (Kleinklasse)' },
                { value: 7, label: 'Privatschulung' },
                { value: 8, label: 'Frühbereich' },
                { value: 9, label: 'Andere' },
              ],
            },
          },
          {
            id: '17d28027-c4bd-4feb-897a-e7d85364d1aa',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Bemerkungen',
            },
          },
          {
            id: '3dc8b628-60f8-4170-9efa-d3de993ec524',
            type: 'input',
            component: 'select',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              label: 'Klassenstufe',
              options: [
                { value: 1, label: 'Eintritt Kindergarten' },
                { value: 2, label: '1. Kindergarten' },
                { value: 3, label: '2. Kindergarten' },
                { value: 4, label: '1. Primar' },
                { value: 5, label: '2. Primar' },
                { value: 6, label: '3. Primar' },
                { value: 7, label: '4. Primar' },
                { value: 8, label: '5. Primar' },
                { value: 9, label: '6. Primar' },
                { value: 10, label: '1. Sek' },
                { value: 11, label: '2. Sek' },
                { value: 12, label: '3. Sek' },
                { value: 13, label: 'Andere' },
              ],
            },
          },
        ],
      },
    ],
  },
  {
    type: 'section',
    label: 'Anmeldung & Fragestellung',
    heading: 'Anmeldung und Fragestellung',
    children: [
      {
        type: 'group',
        children: [
          {
            id: '424a31be-91b3-4a31-865b-1edd20f8d107',
            type: 'input',
            component: 'select',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Zuständige Schulgemeinde',
              tooltip: 'Bezeichnet die entscheidende und bezahlende Schulgemeinde.',
              options: [
                { value: 'xxx', label: 'Andere' },
                { value: 1, label: 'Gemeinde Altikon', deprecated: true },
                { value: 2, label: 'Gemeinde Bäretswil', deprecated: true },
                { value: 3, label: 'Gemeinde Bassersdorf', deprecated: true },
                { value: 4, label: 'Gemeinde Bauma', deprecated: true },
                { value: 5, label: 'Gemeinde Brütten', deprecated: true },
                { value: 6, label: 'Gemeinde Dällikon', deprecated: true },
                { value: 7, label: 'Gemeinde Dättlikon', deprecated: true },
                { value: 8, label: 'Gemeinde Dinhard', deprecated: true },
                { value: 9, label: 'Gemeinde Dürnten', deprecated: true },
                { value: 10, label: 'Gemeinde Embrach', deprecated: true },
                { value: 11, label: 'Gemeinde Erlenbach', deprecated: true },
                { value: 12, label: 'Gemeinde Fehraltorf', deprecated: true },
                { value: 13, label: 'Gemeinde Greifensee', deprecated: true },
                { value: 14, label: 'Gemeinde Hagenbuch', deprecated: true },
                { value: 15, label: 'Gemeinde Hausen am Albis', deprecated: true },
                { value: 16, label: 'Gemeinde Hedingen', deprecated: true },
                { value: 17, label: 'Gemeinde Henggart', deprecated: true },
                { value: 18, label: 'Gemeinde Herrliberg', deprecated: true },
                { value: 19, label: 'Gemeinde Hombrechtikon', deprecated: true },
                { value: 20, label: 'Gemeinde Horgen', deprecated: true },
                { value: 21, label: 'Gemeinde Kappel am Albis', deprecated: true },
                { value: 22, label: 'Gemeinde Kilchberg', deprecated: true },
                { value: 23, label: 'Gemeinde Langnau am Albis', deprecated: true },
                { value: 24, label: 'Gemeinde Lindau', deprecated: true },
                { value: 25, label: 'Gemeinde Lufingen', deprecated: true },
                { value: 26, label: 'Gemeinde Männedorf', deprecated: true },
                { value: 27, label: 'Gemeinde Maur', deprecated: true },
                { value: 28, label: 'Gemeinde Mönchaltorf', deprecated: true },
                { value: 29, label: 'Gemeinde Neftenbach', deprecated: true },
                { value: 30, label: 'Gemeinde Niederhasli', deprecated: true },
                { value: 31, label: 'Gemeinde Nürensdorf', deprecated: true },
                { value: 32, label: 'Gemeinde Oberengstringen', deprecated: true },
                { value: 33, label: 'Gemeinde Oberrieden', deprecated: true },
                { value: 34, label: 'Gemeinde Oetwil am See', deprecated: true },
                { value: 35, label: 'Gemeinde Otelfingen', deprecated: true },
                { value: 36, label: 'Gemeinde Pfäffikon', deprecated: true },
                { value: 37, label: 'Gemeinde Pfungen', deprecated: true },
                { value: 38, label: 'Gemeinde Rafz', deprecated: true },
                { value: 39, label: 'Gemeinde Rheinau', deprecated: true },
                { value: 40, label: 'Gemeinde Richterswil', deprecated: true },
                { value: 41, label: 'Gemeinde Rifferswil', deprecated: true },
                { value: 42, label: 'Gemeinde Rüschlikon', deprecated: true },
                { value: 43, label: 'Gemeinde Russikon', deprecated: true },
                { value: 44, label: 'Gemeinde Seegräben', deprecated: true },
                { value: 45, label: 'Gemeinde Seuzach', deprecated: true },
                { value: 46, label: 'Gemeinde Stallikon', deprecated: true },
                { value: 47, label: 'Gemeinde Thalheim an der Thur', deprecated: true },
                { value: 48, label: 'Gemeinde Thalwil', deprecated: true },
                { value: 49, label: 'Gemeinde Uetikon am See', deprecated: true },
                { value: 50, label: 'Gemeinde Wald', deprecated: true },
                { value: 51, label: 'Gemeinde Wangen-Brüttisellen', deprecated: true },
                { value: 52, label: 'Gemeinde Weiningen', deprecated: true },
                { value: 53, label: 'Gemeinde Weisslingen', deprecated: true },
                { value: 54, label: 'Gemeinde Zell', deprecated: true },
                { value: 55, label: 'Gemeinde Zollikon', deprecated: true },
                { value: 56, label: 'Oberstufe Stadel', deprecated: true },
                { value: 57, label: 'Oberstufenschule Nänikon-Greifensee', deprecated: true },
                { value: 58, label: 'Oberstufenschule Wädenswil Schönenberg Hütten', deprecated: true },
                { value: 59, label: 'Oberstufenschulgemeinde Weiningen', deprecated: true },
                { value: 60, label: 'Primarschulgemeinde Adlikon' },
                { value: 61, label: 'Primarschulgemeinde Aesch' },
                { value: 62, label: 'Primarschulgemeinde Aeugst am Albis' },
                { value: 171, label: 'Primarschulgemeinde Affoltern am Albis' },
                { value: 172, label: 'Primarschulgemeinde Altikon' },
                { value: 63, label: 'Primarschulgemeinde Andelfingen' },
                { value: 64, label: 'Primarschulgemeinde Bachenbülach' },
                { value: 65, label: 'Primarschulgemeinde Bachs' },
                { value: 66, label: 'Primarschulgemeinde Benken' },
                { value: 67, label: 'Primarschulgemeinde Birmensdorf' },
                { value: 68, label: 'Primarschulgemeinde Bonstetten' },
                { value: 69, label: 'Primarschulgemeinde Boppelsen' },
                { value: 173, label: 'Primarschulgemeinde Buchs' },
                { value: 174, label: 'Primarschulgemeinde Bülach' },
                { value: 70, label: 'Primarschulgemeinde Dachsen' },
                { value: 71, label: 'Primarschulgemeinde Dägerlen' },
                { value: 175, label: 'Primarschulgemeinde Dällikon' },
                { value: 72, label: 'Primarschulgemeinde Dänikon-Hüttikon' },
                { value: 176, label: 'Primarschulgemeinde Dättlikon' },
                { value: 73, label: 'Primarschulgemeinde Dielsdorf' },
                { value: 177, label: 'Primarschulgemeinde Dinhard' },
                { value: 178, label: 'Primarschulgemeinde Dübendorf' },
                { value: 74, label: 'Primarschulgemeinde Elgg' },
                { value: 75, label: 'Primarschulgemeinde Ellikon an der Thur' },
                { value: 179, label: 'Primarschulgemeinde Embrach' },
                { value: 76, label: 'Primarschulgemeinde Flurlingen' },
                { value: 180, label: 'Primarschulgemeinde Greifensee' },
                { value: 181, label: 'Primarschulgemeinde Hagenbuch' },
                { value: 182, label: 'Primarschulgemeinde Hausen am Albis' },
                { value: 183, label: 'Primarschulgemeinde Henggart' },
                { value: 77, label: 'Primarschulgemeinde Hettlingen' },
                { value: 78, label: 'Primarschulgemeinde Hochfelden' },
                { value: 79, label: 'Primarschulgemeinde Höri' },
                { value: 80, label: 'Primarschulgemeinde Humlikon' },
                { value: 184, label: 'Primarschulgemeinde Kappel a. Albis' },
                { value: 81, label: 'Primarschulgemeinde Knonau' },
                { value: 82, label: 'Primarschulgemeinde Laufen-Uhwiesen' },
                { value: 185, label: 'Primarschulgemeinde Lufingen' },
                { value: 83, label: 'Primarschulgemeinde Marthalen' },
                { value: 84, label: 'Primarschulgemeinde Maschwanden' },
                { value: 85, label: 'Primarschulgemeinde Mettmenstetten' },
                { value: 86, label: 'Primarschulgemeinde Neerach' },
                { value: 87, label: 'Primarschulgemeinde Niederglatt' },
                { value: 250, label: 'Primarschulgemeinde Niederhasli' },
                { value: 88, label: 'Primarschulgemeinde Oberembrach' },
                { value: 186, label: 'Primarschulgemeinde Oberglatt' },
                { value: 89, label: 'Primarschulgemeinde Obfelden' },
                { value: 90, label: 'Primarschulgemeinde Oetwil-Geroldswil' },
                { value: 91, label: 'Primarschulgemeinde Ossingen' },
                { value: 187, label: 'Primarschulgemeinde Otelfingen' },
                { value: 92, label: 'Primarschulgemeinde Ottenbach' },
                { value: 93, label: 'Primarschulgemeinde Regensberg' },
                { value: 94, label: 'Primarschulgemeinde Regensdorf' },
                { value: 188, label: 'Primarschulgemeinde Rheinau' },
                { value: 95, label: 'Primarschulgemeinde Rickenbach' },
                { value: 189, label: 'Primarschulgemeinde Rifferswil' },
                { value: 96, label: 'Primarschulgemeinde Rümlang' },
                { value: 97, label: 'Primarschulgemeinde Schwerzenbach' },
                { value: 190, label: 'Primarschulgemeinde Seuzach' },
                { value: 98, label: 'Primarschulgemeinde Stadel' },
                { value: 191, label: 'Primarschulgemeinde Stallikon' },
                { value: 192, label: 'Primarschulgemeinde Steinmaur' },
                { value: 99, label: 'Primarschulgemeinde Trüllikon' },
                { value: 100, label: 'Primarschulgemeinde Truttikon' },
                { value: 101, label: 'Primarschulgemeinde Turbenthal' },
                { value: 102, label: 'Primarschulgemeinde Unterengstringen' },
                { value: 194, label: 'Primarschulgemeinde Uster' },
                { value: 195, label: 'Primarschulgemeinde Wädenswil' },
                { value: 103, label: 'Primarschulgemeinde Weiach' },
                { value: 196, label: 'Primarschulgemeinde Weiningen' },
                { value: 104, label: 'Primarschulgemeinde Wettswil am Albis' },
                { value: 105, label: 'Primarschulgemeinde Wila' },
                { value: 106, label: 'Primarschulgemeinde Wildberg' },
                { value: 107, label: 'Primarschulgemeinde Winkel' },
                { value: 193, label: 'Primarschulgemeinde Thalheim a. d. Thur' },
                { value: 197, label: 'Schulgemeinde Adliswil' },
                { value: 133, label: 'Schule Affoltern am Albis', deprecated: true },
                { value: 198, label: 'Schulgemeinde Bäretswil' },
                { value: 199, label: 'Schulgemeinde Bassersdorf' },
                { value: 200, label: 'Schulgemeinde Bauma' },
                { value: 201, label: 'Schulgemeinde Brütten' },
                { value: 108, label: 'Schulgemeinde Bubikon' },
                { value: 202, label: 'Schulgemeinde Dietikon' },
                { value: 109, label: 'Schulgemeinde Dietlikon' },
                { value: 203, label: 'Schulgemeinde Dürnten' },
                { value: 110, label: 'Schulgemeinde Egg' },
                { value: 111, label: 'Schulgemeinde Eglisau' },
                { value: 204, label: 'Schulgemeinde Elsau-Schlatt' },
                { value: 205, label: 'Schulgemeinde Erlenbach' },
                { value: 112, label: 'Schulgemeinde Fällanden' },
                { value: 206, label: 'Schulgemeinde Fehraltorf' },
                { value: 113, label: 'Schulgemeinde Feuerthalen' },
                { value: 114, label: 'Schulgemeinde Fischenthal' },
                { value: 115, label: 'Schulgemeinde Flaachtal' },
                { value: 116, label: 'Schulgemeinde Glattfelden' },
                { value: 117, label: 'Schulgemeinde Gossau' },
                { value: 118, label: 'Schulgemeinde Grüningen' },
                { value: 207, label: 'Schulgemeinde Hedingen' },
                { value: 208, label: 'Schulgemeinde Herrliberg' },
                { value: 119, label: 'Schulgemeinde Hinwil' },
                { value: 120, label: 'Schulgemeinde Hittnau' },
                { value: 209, label: 'Schule Hochfelden', deprecated: true },
                { value: 210, label: 'Schulgemeinde Hombrechtikon' },
                { value: 211, label: 'Schulgemeinde Horgen' },
                { value: 212, label: 'Schulgemeinde Illnau-Effretikon' },
                { value: 213, label: 'Schulgemeinde Kilchberg' },
                { value: 214, label: 'Schulgemeinde Kloten' },
                { value: 215, label: 'Schulgemeinde Küsnacht' },
                { value: 216, label: 'Schulgemeinde Langnau am Albis' },
                { value: 217, label: 'Schulgemeinde Lindau' },
                { value: 218, label: 'Schulgemeinde Männedorf' },
                { value: 219, label: 'Schulgemeinde Maur' },
                { value: 220, label: 'Schulgemeinde Meilen' },
                { value: 221, label: 'Schulgemeinde Mönchaltorf' },
                { value: 222, label: 'Schulgemeinde Neftenbach' },
                { value: 223, label: 'Schulgemeinde Nürensdorf' },
                { value: 224, label: 'Schulgemeinde Oberengstringen' },
                { value: 225, label: 'Schulgemeinde Oberrieden' },
                { value: 226, label: 'Schulgemeinde Oetwil am See' },
                { value: 227, label: 'Schulgemeinde Opfikon' },
                { value: 228, label: 'Schulgemeinde Pfäffikon' },
                { value: 229, label: 'Schulgemeinde Pfungen' },
                { value: 230, label: 'Schulgemeinde Rafz' },
                { value: 231, label: 'Schulgemeinde Richterswil' },
                { value: 121, label: 'Schulgemeinde Rorbas - Freienstein - Teufen' },
                { value: 232, label: 'Schulgemeinde Rüschlikon' },
                { value: 233, label: 'Schulgemeinde Russikon' },
                { value: 234, label: 'Schulgemeinde Rüti' },
                { value: 235, label: 'Schulgemeinde Schlieren' },
                { value: 236, label: 'Schulgemeinde Seegräben' },
                { value: 122, label: 'Schulgemeinde Stäfa' },
                { value: 237, label: 'Schulgemeinde Stammheim' },
                { value: 132, label: 'Schule Steinmaur', deprecated: true },
                { value: 238, label: 'Schulgemeinde Thalwil' },
                { value: 239, label: 'Schulgemeinde Uetikon am See' },
                { value: 123, label: 'Schulgemeinde Uitikon' },
                { value: 124, label: 'Schulgemeinde Unteres Rafzerfeld' },
                { value: 125, label: 'Schulgemeinde Urdorf' },
                { value: 126, label: 'Schulgemeinde Volketswil' },
                { value: 240, label: 'Schulgemeinde Wald ZH' },
                { value: 127, label: 'Schulgemeinde Wallisellen' },
                { value: 241, label: 'Schulgemeinde Wangen-Brüttisellen' },
                { value: 128, label: 'Schulgemeinde Wehntal' },
                { value: 251, label: 'Schulgemeinde Weiningen' },
                { value: 242, label: 'Schulgemeinde Weisslingen' },
                { value: 131, label: 'Schulgemeinde Wetzikon' },
                { value: 129, label: 'Schulgemeinde Wiesendangen' },
                { value: 243, label: 'Schulgemeinde Zell' },
                { value: 244, label: 'Schulgemeinde Zollikon' },
                { value: 130, label: 'Schulgemeinde Zumikon' },
                { value: 134, label: 'Sekundarschulgemeinde Affoltern am Albis-Aeugst' },
                { value: 135, label: 'Sekundarschulgemeinde Andelfingen' },
                { value: 136, label: 'Sekundarschulgemeinde Birmensdorf-Aesch' },
                { value: 137, label: 'Sekundarschulgemeinde Bonstetten' },
                { value: 138, label: 'Sekundarschulgemeinde Bülach' },
                { value: 139, label: 'Sekundarschulgemeinde Dielsdorf' },
                { value: 140, label: 'Sekundarschulgemeinde Dübendorf-Schwerzenbach' },
                { value: 141, label: 'Sekundarschulgemeinde Elgg' },
                { value: 142, label: 'Sekundarschulgemeinde Embrach' },
                { value: 252, label: 'Sekundarschulgemeinde Erlenbach-Herrliberg' },
                { value: 143, label: 'Sekundarschulgemeinde Hausen am Albis' },
                { value: 245, label: 'Sekundarschulgemeinde Kilchberg-Rüschlikon' },
                { value: 144, label: 'Sekundarschulgemeinde Knonau-Maschwanden-Mettmenstetten' },
                { value: 145, label: 'Sekundarschulgemeinde Marthalen' },
                { value: 246, label: 'Sekundarschulgemeinde Nänikon-Greifensee' },
                { value: 156, label: 'Sekundarschulgemeinde Niederhasli Niederglatt' },
                { value: 146, label: 'Sekundarschulgemeinde Obfelden-Ottenbach' },
                { value: 147, label: 'Sekundarschulgemeinde Ossingen-Truttikon' },
                { value: 148, label: 'Sekundarschulgemeinde Regensdorf-Buchs-Dällikon' },
                { value: 157, label: 'Sekundarschulgemeinde Rickenbach' },
                { value: 149, label: 'Sekundarschulgemeinde Rümlang-Oberglatt' },
                { value: 150, label: 'Sekundarschulgemeinde Seuzach' },
                { value: 247, label: 'Sekundarschulgemeinde Stadel' },
                { value: 151, label: 'Sekundarschulgemeinde Turbenthal-Wildberg' },
                { value: 152, label: 'Sekundarschulgemeinde Uhwiesen' },
                { value: 153, label: 'Sekundarschulgemeinde Unteres Furttal' },
                { value: 158, label: 'Sekundarschulgemeinde Uster' },
                { value: 248, label: 'Sekundarschulgemeinde Wädenswil-Schönenberg-Hütten' },
                { value: 155, label: 'Sekundarschulgemeinde Wila' },
                { value: 249, label: 'Sekunderschulgemeinde Weiningen' },
                { value: 154, label: 'Sekundarschule Wetzikon-Seegräben', deprecated: true },
                { value: 159, label: 'Stadt Adliswil', deprecated: true },
                { value: 160, label: 'Stadt Bülach', deprecated: true },
                { value: 161, label: 'Stadt Dietikon', deprecated: true },
                { value: 162, label: 'Stadt Dübendorf', deprecated: true },
                { value: 163, label: 'Stadt Illnau-Effretikon', deprecated: true },
                { value: 164, label: 'Stadt Kloten', deprecated: true },
                { value: 165, label: 'Stadt Opfikon', deprecated: true },
                { value: 166, label: 'Stadt Schlieren', deprecated: true },
                { value: 167, label: 'Stadt Uster', deprecated: true },
                { value: 168, label: 'Stadt Wädenswil', deprecated: true },
                { value: 169, label: 'Stadt Winterthur' },
                { value: 170, label: 'Stadt Zürich' },
              ],
            },
          },
          {
            id: '616352bf-10c8-42a4-b1da-a61499daab84',
            type: 'input',
            component: 'select',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Einverständnis der Eltern / Erziehungsberechtigten vorliegend?',
              options: [
                { value: 'yes', label: 'Ja' },
                { value: 'no', label: 'Nein' },
              ],
            },
          },
          {
            id: '7758d0e8-30fe-4abb-b2f3-7f8b08fe5d4b',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Zusammenfassung der Fragestellung',
            },
          },
          {
            id: 'ef336306-436b-42a9-ae2f-89478532a74d',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Anmeldung erfolgte durch (Name, Vorname, Funktion, Institution, Ort, Adresse, Telefon, Email)',
              tooltip: 'Bei Sonderschulung erfolgt die Anmeldung immer durch die Schulpflege bzw. eine durch sie bezeichnete Stelle. Funktion angeben, fakultativ mit Namen.',
            },
          },
          {
            id: '46d2eaa7-950e-4f4e-a806-155d88ac92ec',
            type: 'input',
            component: 'datepicker',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Datum Eingang am',
            },
          },
          {
            id: 'f1601f2d-b9d4-45d3-89a9-045cb79108fa',
            type: 'input',
            component: 'datepicker',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Beginn SPD Abklärung',
              tooltip: 'Basisabklärung, zwingend ein Datum, bei Bedarf erläuternder Text.',
            },
          },
          {
            id: '7a89ff8c-d134-4e9a-b61a-b1ae3bd37847',
            type: 'input',
            component: 'datepicker',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Abklärungsgespräch vom (Datum)',
              tooltip: 'Datum des Gesprächs, an dem Einschätzungen und Empfehlung kommuniziert und Ziele besprochen wurden.',
            },
          },
          {
            id: '3899d19d-453d-4a55-bd51-c3fc0c2ac51f',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Mit den folgenden Beteiligten',
              tooltip: 'Funktionen der am Abklärungsgespräch beteiligten Personen angeben, fakultativ mit Namen.',
            },
          },
          {
            id: '5c14d448-fdd2-41ac-819b-081145b5778a',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Berücksichtigte Berichte',
              tooltip: 'Unbedingt Datum und Verfasser/Institution angeben. Auch frühere schulpsychologische Berichte aufführen.',
            },
          },
        ],
      },
    ],
  },
  {
    type: 'section',
    label: 'Professioneller Kontext',
    heading: 'Schulischer / professioneller Kontext (inkl. Frühbereich)',
    children: [
      {
        type: 'group',
        children: [
          {
            id: 'c41cc3cf-f60f-475a-815c-9cd3ef2b843c',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Schullaufbahn',
              tooltip: 'Ein "regulär" reicht bei regulärer Schullaufbahn ohne Besonderheiten. Bei Besonderheiten den Ablauf der Schullaufbahn beschreiben, nur Fakten.',
            },
          },
          {
            id: 'f83b66bc-566b-4eb4-97b1-5b137fe628f7',
            type: 'input',
            component: 'checkbox-group',
            for_state: true,
            for_report: true,
            required: false,
            props: {
              classes: ['three-columns'],
              label: 'Besondere Massnahmen, die derzeit <b>am Hauptförderort</b> angeboten werden',
              value: [],
              options: [
                { value: 1, label: 'Keine' },
                { value: 2, label: 'Integrative Förderung (IF)' },
                { value: 3, label: 'Nachteilsausgleich' },
                { value: 4, label: 'Deutsch als Zweitsprache' },
                { value: 5, label: 'Logopädie' },
                { value: 6, label: 'Psychomotorik' },
                { value: 7, label: 'Psychotherapie' },
                { value: 8, label: 'Audiopädagogik' },
                { value: 9, label: 'Begabungs- und Begabtenförderung' },
                { value: 10, label: 'Einschulungsklasse' },
                { value: 11, label: 'Kleinklasse' },
                { value: 12, label: 'Aufnahmeklasse' },
                { value: 13, label: 'Integrierte Sonderschulung in der Verantwortung der Regelschule' },
                { value: 14, label: 'Integrierte Sonderschulung in der Verantwortung der Sonderschule' },
                { value: 15, label: 'Einzelunterricht' },
                { value: 16, label: 'Schulassistenz' },
                { value: 17, label: 'Sozialpädagogische Unterstützung' },
                { value: 18, label: 'Aufgabenhilfe' },
                { value: 19, label: 'HFE (Heilpädagogische Früherziehung)' },
                { value: 20, label: 'Andere' },
              ],
            },
          },
          {
            id: 'f3594d1a-c774-4c65-8160-87aced47251a',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Bemerkungen / Erläuterungen',
            },
          },
          {
            id: '29cd9c80-cc75-4774-afb4-b874c419f7b3',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Besondere Massnahmen, die derzeit <b>ausserhalb des Hauptförderorts</b> angeboten werden (seit wann?)',
              tooltip: 'Alle nichtschulischen Massnahmen, die dem Kind angeboten werden und mit der aktuellen Fragestellung im Zusammenhang stehen.',
              export: { default: 'Besondere Massnahmen ausserhalb Hauptförderort' },
            },
          },
          {
            id: '07c5e52d-665f-4714-a78b-5b1292c3ed35',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Besondere Massnahmen, die derzeit nicht direkt dem Kind/dem Jugendlichen,<br/> sondern <b>seinem Umfeld</b> angeboten werden (seit wann?)',
              export: { default: 'Besondere Massnahmen für das Umfeld' },
            },
          },
          {
            id: '5639c0af-b1fc-46a5-af6f-54cf5f88fb66',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Welche besonderen Massnahmen und deren Dauer, die <b>in der Vergangenheit</b> angeboten wurden, erscheinen für das Verständnis der aktuellen Situation relevant und wie lange wurden sie angeboten?',
              export: { default: 'Besondere Massnahmen früher' },
            },
          },
        ],
      },
      {
        type: 'group',
        label: 'Fördernde und beeinträchtigende Bedingungen',
        children: [
          {
            id: '2efa8f22-e8f0-4783-af63-6ff0c3f01431',
            type: 'input',
            component: 'checkbox-group',
            for_state: false,
            for_report: true,
            required: true,
            props: {
              label: 'Bedingungen, die sich fördernd auswirken («Schutzfaktoren»)',
              value: [],
              options: [
                { value: 1, label: 'Angebote und Ressourcen' },
                { value: 2, label: 'Unterstützung und Beziehungen' },
                { value: 3, label: 'Räumlichkeiten, materielle Ausstattung' },
                { value: 4, label: 'Persönliche Hilfsmittel' },
                { value: 5, label: 'Keine bekannt' },
              ],
            },
          },
          {
            id: 'f0752560-4129-49a0-b019-dee9befa278d',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Bemerkungen / Erläuterungen',
            },
          },
          {
            id: '79f8d79f-408c-4bfc-b736-da49a6ef5633',
            type: 'input',
            component: 'checkbox-group',
            for_state: false,
            for_report: true,
            required: true,
            props: {
              label: 'Bedingungen, die sich beeinträchtigend auswirken («Risikofaktoren»)',
              value: [],
              options: [
                { value: 1, label: 'Angebote und Ressourcen' },
                { value: 2, label: 'Unterstützung und Beziehungen' },
                { value: 3, label: 'Räumlichkeiten, materielle Ausstattung' },
                { value: 4, label: 'Persönliche Hilfsmittel' },
                { value: 5, label: 'Keine bekannt' },
              ],
            },
          },
          {
            id: 'e63ad6fb-caf0-408b-b7b3-4b3fbdc53046',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Bemerkungen / Erläuterungen',
            },
          },
          {
            id: '910a1979-065b-4c5b-9907-d2487f4f0514',
            type: 'input',
            component: 'radio-group',
            for_state: true,
            for_report: false,
            required: true,
            props: {
              label: 'Einschätzung professioneller Kontext',
              options: [
                { value: 1, label: 'beeinträchtigend' },
                { value: 2, label: 'neutral' },
                { value: 3, label: 'fördernd' },
                { value: 4, label: 'Keine Angabe' },
              ],
            },
          },
          {
            id: 'bd07cb17-eea2-481a-a745-bea3a194e5d5',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: false,
            required: false,
            props: {
              label: 'Qualifizierende Begründung',
            },
          },
        ],
      },
    ],
  },
  {
    type: 'section',
    label: 'Familiärer Kontext',
    heading: 'Familiärer Kontext',
    children: [
      {
        type: 'group',
        children: [
          {
            id: '3b22b989-68ec-4039-8a17-a996ac4451a1',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: true,
            props: {
              label: 'Lebens- und Betreuungssituation',
              tooltip: 'Aktuelle Situation. Wo wohnt und lebt das Kind / der Jugendliche? Wer betreut? Zusammensetzung der Familie?',
            },
          },
          {
            id: '82012723-526a-4969-9c1b-dd232c97a808',
            type: 'input',
            component: 'select',
            for_state: false,
            for_report: true,
            required: true,
            props: {
              label: 'Geschwister (Anzahl eingeben)',
              tooltip: 'Im Abschnitt Lebens- und Betreuungssituation können weitere Angaben wie jünger/älter, Halbgeschwister oder Jahrgang gemacht werden .',
              options: [
                { value: 1, label: 'keine' },
                { value: 2, label: '1' },
                { value: 3, label: '2' },
                { value: 4, label: '3' },
                { value: 5, label: '4' },
                { value: 6, label: '5' },
                { value: 7, label: '6' },
                { value: 8, label: '7' },
                { value: 9, label: '8' },
                { value: 10, label: '9' },
                { value: 11, label: '10' },
                { value: 12, label: '11' },
                { value: 13, label: '12' },
                { value: 14, label: '13' },
                { value: 15, label: '14' },
                { value: 16, label: '15' },
              ],
            },
          },
          {
            id: 'ced909ae-dcf7-400f-88db-9b8d0531fb4d',
            type: 'input',
            component: 'select',
            for_state: false,
            for_report: true,
            required: true,
            export: false,
            props: {
              label: 'Geschwisterstellung (Erstgeborenes = 1)',
              options: [
                { value: 1, label: '1' },
                { value: 2, label: '2' },
                { value: 3, label: '3' },
                { value: 4, label: '4' },
                { value: 5, label: '5' },
                { value: 6, label: '6' },
                { value: 7, label: '7' },
                { value: 8, label: '8' },
                { value: 9, label: '9' },
                { value: 10, label: '10' },
                { value: 11, label: '11' },
                { value: 12, label: '12' },
                { value: 13, label: '13' },
                { value: 14, label: '14' },
                { value: 15, label: '15' },
              ],
            },
          },
          {
            id: '8d35e3a5-4f7e-4615-97c5-b6e9157f87fb',
            type: 'input',
            component: 'select',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              label: 'Wohnt in der Schweiz seit Jahr',
              options: [
                { value: '{birthyear}', label: 'seit Geburt' },
                { value: 2023, label: '2023' },
                { value: 2022, label: '2022' },
                { value: 2021, label: '2021' },
                { value: 2020, label: '2020' },
                { value: 2019, label: '2019' },
                { value: 2018, label: '2018' },
                { value: 2017, label: '2017' },
                { value: 2016, label: '2016' },
                { value: 2015, label: '2015' },
                { value: 2014, label: '2014' },
                { value: 2013, label: '2013' },
                { value: 2012, label: '2012' },
                { value: 2011, label: '2011' },
                { value: 2010, label: '2010' },
                { value: 2009, label: '2009' },
                { value: 2008, label: '2008' },
                { value: 2007, label: '2007' },
                { value: 2006, label: '2006' },
                { value: 2005, label: '2005' },
                { value: 2004, label: '2004' },
                { value: 2003, label: '2003' },
                { value: 2002, label: '2002' },
                { value: 2001, label: '2001' },
                { value: 2000, label: '2000' },
                { value: 1999, label: '1999' },
              ],
            },
          },
          {
            id: 'e64be550-ac2a-4bcd-997a-094898a6bf22',
            type: 'input',
            component: 'select',
            for_state: false,
            for_report: true,
            required: false,
            export: false,
            props: {
              label: 'Monat',
              options: [
                { value: 1, label: '1' },
                { value: 2, label: '2' },
                { value: 3, label: '3' },
                { value: 4, label: '4' },
                { value: 5, label: '5' },
                { value: 6, label: '6' },
                { value: 7, label: '7' },
                { value: 8, label: '8' },
                { value: 9, label: '9' },
                { value: 10, label: '10' },
                { value: 11, label: '11' },
                { value: 12, label: '12' },
              ],
            },
          },
          {
            id: '28c4bacd-7e53-40f8-be69-e58d2151e435',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: true,
            props: {
              label: 'Weitere Angaben zur <b>aktuellen</b> familiären Situation',
            },
          },
          {
            id: 'e0ca034a-0369-44f0-89b4-2d43a668a61d',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: true,
            props: {
              label: 'Weitere Angaben zur <b>vergangenen</b> familiären Situation',
            },
          },
        ],
      },
      {
        type: 'group',
        label: 'Zeitlich überwiegender Aufenthaltsort des Kindes / Jugendlichen',
        children: [
          {
            id: '79d909a7-e458-461f-b53d-dae44deaa443',
            type: 'input',
            component: 'checkbox-group',
            for_state: false,
            for_report: false,
            required: false,
            props: {
              label: 'Zeitlich überwiegender Aufenthaltsort',
              value: [],
              options: [
                { value: 1, label: 'Im familiären Umfeld' },
                { value: 2, label: 'Am Hauptförderort' },
                { value: 3, label: 'Anderswo (z.B. Tagesfamilie)' },
              ],
            },
          },
          {
            id: 'fd469ec4-2f29-4da0-9b4b-c338441c32e2',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: false,
            required: false,
            props: {
              label: 'Bemerkungen / Detailangaben',
            },
          },
        ],
      },
      {
        type: 'group',
        label: 'Fördernde und beeinträchtigende Bedingungen',
        children: [
          {
            id: 'f2bd5a21-8c08-44c4-97d2-f994be438edb',
            type: 'input',
            component: 'checkbox-group',
            for_state: false,
            for_report: true,
            required: true,
            props: {
              label: 'Bedingungen, die sich fördernd auswirken («Schutzfaktoren»)',
              value: [],
              options: [
                { value: 1, label: 'Unterstützung und Beziehungen' },
                { value: 2, label: 'Räumlichkeiten, materielle Ausstattung' },
                { value: 3, label: 'Persönliche Hilfsmittel' },
                { value: 4, label: 'Keine bekannt' },
                { value: 5, label: 'Andere' },
              ],
            },
          },
          {
            id: '4f5a9866-7c85-4594-8a78-5889c5a29536',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Bemerkungen / Erläuterungen',
            },
          },
          {
            id: '3b6ebfae-251e-4269-93ac-849ac3664172',
            type: 'input',
            component: 'checkbox-group',
            for_state: false,
            for_report: true,
            required: true,
            props: {
              label: 'Bedingungen, die sich beeinträchtigend auswirken («Risikofaktoren»)',
              value: [],
              options: [
                { value: 1, label: 'Unterstützung und Beziehungen' },
                { value: 2, label: 'Räumlichkeiten, materielle Ausstattung' },
                { value: 3, label: 'Persönliche Hilfsmittel' },
                { value: 4, label: 'Keine bekannt' },
                { value: 5, label: 'Andere' },
              ],
            },
          },
          {
            id: '0a06f85b-36c9-4fff-bc44-45b65d0437e2',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Bemerkungen / Erläuterungen',
            },
          },
        ],
      },
      {
        type: 'group',
        label: 'Relevante gesundheitliche Risikofaktoren und kritische Lebensereignisse',
        children: [
          {
            id: '18ffa49a-128f-480b-adbf-06986746fc97',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Bekannte relevante Erschwerungen in der Herkunftsfamilie',
            },
          },
          {
            id: '5ac1161e-1128-4067-9c2e-451d8da07eb6',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Besondere Belastungen während der Schwangerschaft und/oder während der (frühen) Kindheit sowie besondere Lebensereignisse',
              tooltip: 'Z.B. Erbkrankheiten, Behinderungen, schwere körperliche/psychische/chronische Erkrankungen.',
            },
          },
        ],
      },
      {
        type: 'group',
        label: 'Einschätzung familiärer Kontext',
        children: [
          {
            id: 'f7147d48-84ce-4487-a228-c9fe229d8849',
            type: 'input',
            component: 'radio-group',
            for_state: true,
            for_report: false,
            required: true,
            props: {
              label: 'Einschätzung familiärer Kontext',
              options: [
                { value: 1, label: 'beeinträchtigend' },
                { value: 2, label: 'neutral' },
                { value: 3, label: 'fördernd' },
                { value: 4, label: 'keine Angabe' },
              ],
            },
          },
          {
            id: '515d5d7f-6e9d-4c15-a03f-1641d6371b99',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: false,
            required: false,
            props: {
              label: 'Qualifizierende Begründung',
            },
          },
        ],
      },
    ],
  },

  {
    type: 'section',
    label: 'ICF-Erfassung',
    heading: 'Kind / Jugendlicher: Indikationsbereiche mit Funktionen, Aktivitäten und Partizipation ICF',
    children: [
      {
        type: 'group',
        exportType: 'icf',
        label: 'Kognition und Metakognition',
        children: [
          {
            id: '04f86a45-8851-4487-8abe-dd603a3fdacf',
            type: 'input',
            component: 'radio-group',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              classes: ['noicons', 'noborder'],
              fallback: false,
              options: [
                { value: 1, label: 'oberhalb Schwelle' },
                { value: 2, label: 'unterhalb Schwelle' },
              ],
            },
          },
          {
            id: '71e38acd-41a3-4c71-b5ba-0a95c9583cca',
            type: 'input',
            component: 'radio-matrix',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              dynamic: true,
              dynamicLabel: 'Weiteres ICF-Item hinzufügen',
              choices: [
                { value: 1, label: 'kein Problem / Ressource' },
                { value: 2, label: 'Problem leicht-mässig' },
                { value: 3, label: 'Problem erheblich-voll' },
                { value: 4, label: 'k.A., nicht spezif., nicht anwendb.' },
              ],
              value: [
                {
                  label: 'Funktionen der Orientierung',
                  info: 'Allgemeine mentale Funktionen, die das Erkennen und Ermitteln der Beziehung zu Objekten, zu sich selber, zu anderen Personen, zu Zeit, Umgebung und Raum betreffen. Inkl.: Funktionen der Orientierung zu Zeit, Raum, Ort und Person sowie der Orientierung zur eigenen Person und zu anderen Personen; Desorientierung zu Zeit, Ort und Person.<br/> Exkl.: Funktionen des Bewusstseins (b110), Funktionen der Aufmerksamkeit (b140); Funktionen des Gedächtnisses (b144).',
                  dynamic: false,
                },
                {
                  label: 'Funktionen der Aufmerksamkeit',
                  info: 'Spezifische mentale Funktionen, die die Fokussierung auf einen externen Reiz oder auf innere Vorgänge für eine geforderte Zeitspanne betreffen.<br/>Inkl.: Funktionen, die Daueraufmerksamkeit, Wechsel der Aufmerksamkeit, geteilte Aufmerksamkeit, mit anderen geteilte Aufmerksamkeit, Konzentration und Ablenkbarkeit betreffen.<br/>Exkl.: Funktionen des Bewusstseins (b110); Funktionen der psychischen Energie und des Antriebs (b130); Funktionen des Schlafes (b134); Funktionen des Gedächtnisses (b144); Psychomotorische Funktionen (b147); Funktionen der Wahrnehmung (b156).',
                  dynamic: false,
                },
                {
                  label: 'Funktionen des Gedächtnisses',
                  info: 'Spezifische mentale Funktionen, die die adäquate Registrierung, die Speicherung und den Abruf von Informationen betreffen.',
                  dynamic: false,
                },
                {
                  label: 'Höhere kognitive Funktionen',
                  info: 'Spezifische mentale Funktionen, die insbesondere von den Frontallappen des Gehirns abhängen, einschließlich komplexe zielgerichtete Verhaltensweisen wie Entscheidungen treffen, abstrakt denken sowie einen Plan aufstellen und durchführen, mentale Flexibilität, sowie entscheiden, welche Verhaltensweisen unter welchen Umständen angemessen sind (häufig „exekutive Funktionen“ genannt).<br/>Inkl.: Funktionen, die Abstraktionsvermögen und Ordnen von Ideen betreffen; Zeitmanagement, Einsichts- und Urteilsvermögen; Konzeptbildung, Kategorisierung und kognitive Flexibilität.<br/>Exkl.: Funktionen des Gedächtnisses (b144); Funktionen des Denkens (b160); Kognitiv-sprachliche Funktionen (b167); Das Rechnen betreffende Funktionen (b172)',
                  dynamic: false,
                },
                {
                  label: 'Zuschauen',
                  info: 'Absichtsvoll den Sehsinn zu benutzen, um visuelle Reize wahrzunehmen, wie einer Sportveranstaltung oder dem Spiel von Kindern zuschauen.',
                  dynamic: false,
                },
                {
                  label: 'Zuhören',
                  info: 'Absichtsvoll den Hörsinn zu benutzen, um akustische Reize wahrzunehmen, wie Radio, Musik oder einen Vortrag hören.',
                  dynamic: false,
                },
                {
                  label: 'Lernen durch Handlungen mit Gegenständen',
                  info: 'Lernen durch einfache Handlungen mit einem Gegenstand, mit zwei oder mehreren Gegenständen, durch Funktions- oder Symbolspiel wie mit Gegenständen klopfen, Bausteine stossen und spielen mit Puppen oder Autos.',
                  dynamic: false,
                },
                {
                  label: 'Sprache erwerben',
                  info: 'Die Fähigkeit zu entwickeln, Personen, Gegenstände, Ereignisse und Gefühle durch Wörter, Symbole, Redewendungen und Sätze repräsentieren. Exkl.: Zusätzliche Sprache erwerben (d13); Kommunikation (d310-d399)',
                  dynamic: false,
                },
                {
                  label: 'Probleme lösen',
                  info: 'Lösungen für eine Frage oder Situation zu finden, indem das Problem identifiziert und analysiert wird, Lösungsmöglichkeiten entwickelt und die möglichen Auswirkungen der Lösungen abgeschätzt werden und die gewählte Lösung umgesetzt wird, wie die Auseinandersetzung zweier Personen schlichten.<br/>Inkl.: Einfache oder komplexe Probleme lösen<br/>Exkl.: Denken (d163); Entscheidungen treffen (d177)',
                  dynamic: false,
                },
              ],
            },
          },
          {
            id: '271be08d-10ad-446c-9b81-7a8e1eb04b62',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Bemerkungen / Erläuterungen / Hinweise',
            },
          },
        ],
      },
      {
        type: 'group',
        exportType: 'icf',
        label: 'Wahrnehmung und Sensorik',
        children: [
          {
            id: 'c3f977ba-4698-4eec-aa4c-72959054f1ec',
            type: 'input',
            component: 'radio-group',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              classes: ['noicons', 'noborder'],
              fallback: false,
              options: [
                { value: 1, label: 'oberhalb Schwelle' },
                { value: 2, label: 'unterhalb Schwelle' },
              ],
            },
          },
          {
            id: '590f38c3-e3dd-4e23-8fd8-0707d805df67',
            type: 'input',
            component: 'radio-matrix',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              dynamic: true,
              dynamicLabel: 'Weiteres ICF-Item hinzufügen',
              choices: [
                { value: 1, label: 'kein Problem / Ressource' },
                { value: 2, label: 'Problem leicht-mässig' },
                { value: 3, label: 'Problem erheblich-voll' },
                { value: 4, label: 'k.A., nicht spezif., nicht anwendb.' },
              ],
              value: [
                {
                  label: 'Funktionen des Sehens',
                  info: 'Sinnesfunktionen bezüglich der Wahrnehmung von Licht sowie von Form, Größe, Gestalt und Farbe des visuellen Reizes.<br/> Inkl.: Die Sehschärfe betreffende Funktionen; das Gesichtsfeld betreffende Funktionen; Qualität des Sehvermögens; Licht- und Farbwahrnehmung, Sehschärfe bei Weit- und Nahsicht, einäugiges (monokulares) und beidäugiges (binokulares) Sehen; Bildqualität; Funktionsstörungen wie Kurzsichtigkeit (Myopie), Weitsichtigkeit (Hypermetropie), Hornhautverkrümmung (Astigmatismus), Halbseitenblindheit (Hemianopsie), Farbenblindheit, Tunnelsehen, zentrale oder periphere Gesichtsfeldausfälle (Skotome), Doppelbilder (Diplopie), Nachtblindheit, Hell- Dunkeladaptation<br/> Exkl.: Funktionen der Wahrnehmung (b156)',
                  dynamic: false,
                },
                {
                  label: 'Funktionen des Hörens',
                  info: 'Sinnesfunktionen bezüglich der Wahrnehmung von Tönen oder Geräuschen und der Unterscheidung von deren Herkunftsort, Tonhöhe, Lautstärke und Qualität.<br/> Inkl.: Funktionen des Hörens, akustische Differenzierung, Ortung der Geräuschquelle, Richtungshören, Spracherkennung; Funktionsstörungen wie Taubheit, Schwerhörigkeit, Einschränkung des Hörvermögens, Hörverlust<br/>  Exkl.: Funktionen der Wahrnehmung (b156); Kognitiv-sprachliche Funktionen (b167)',
                  dynamic: false,
                },
                {
                  label: 'Schmerz',
                  info: 'Empfinden eines unangenehmen Gefühls, das mögliche oder tatsächliche Schäden einer Körperstruktur anzeigt.<br/> Inkl.: Allgemeiner oder umschriebener Schmerz in einem oder mehreren Körperteilen, Schmerz in einem Dermatom, stechender, brennender, dumpfer, quälender Schmerz; Muskelschmerz (Myalgie), aufgehobene Schmerzempfindung (Analgesie), gesteigerte Schmerzempfindung (Hyperalgesie)',
                  dynamic: false,
                },
                {
                  label: 'Andere bewusste sinnliche Wahrnehmungen',
                  info: 'Absichtsvoll andere elementare Sinne zu benutzen, um Reize wahrzunehmen, wie die materielle Struktur tasten und fühlen, Süßes schmecken oder Blumen riechen.',
                  dynamic: false,
                },
              ],
            },
          },
          {
            id: '1e39cc15-a03e-4145-8c16-deb2c2de385d',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Bemerkungen / Erläuterungen / Hinweise',
            },
          },
        ],
      },
      {
        type: 'group',
        exportType: 'icf',
        label: 'Soziale-emotionale Funktionsfähigkeit',
        children: [
          {
            id: '53d4cb67-a78c-4926-acd3-8a1402e7400f',
            type: 'input',
            component: 'radio-group',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              classes: ['noicons', 'noborder'],
              fallback: false,
              options: [
                { value: 1, label: 'oberhalb Schwelle' },
                { value: 2, label: 'unterhalb Schwelle' },
              ],
            },
          },
          {
            id: 'ecb62461-5ceb-45d0-ac01-374acf58059c',
            type: 'input',
            component: 'radio-matrix',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              dynamic: true,
              dynamicLabel: 'Weiteres ICF-Item hinzufügen',
              choices: [
                { value: 1, label: 'kein Problem / Ressource' },
                { value: 2, label: 'Problem leicht-mässig' },
                { value: 3, label: 'Problem erheblich-voll' },
                { value: 4, label: 'k.A., nicht spezif., nicht anwendb.' },
              ],
              value: [
                {
                  label: 'Funktionen der psychischen Energie und des Antriebs',
                  info: 'Allgemeine mentale Funktionen, die physiologische und psychologische Vorgänge betreffen, welche bei einer Person ein nachhaltiges Streben nach Befriedigung bestimmter Bedürfnisse und die Verfolgung allgemeiner Ziele verursachen.<br/> Inkl.: Funktionen, die psychische Energie, Motivation, Appetit, Sucht (einschließlich Sucht nach Substanzen, die zu einer Abhängigkeit führen) und Impulskontrolle betreffen<br/> Exkl.: Funktionen des Bewusstseins (b110); Funktionen von Temperament und Persönlichkeit (b126); Funktionen des Schlafes (b134); Psychomotorische Funktionen (b147); Emotionale Funktionen (b152)',
                  dynamic: false,
                },
                {
                  label: 'Emotionale Funktionen',
                  info: 'Spezifische mentale Funktionen, die im Zusammenhang mit Gefühlen und den affektiven Komponenten von Bewusstseinsprozessen stehen.<br/> Inkl.: Funktionen, die (Situations)Angemessenheit der Emotion, affektive Kontrolle und Schwingungsfähigkeit betreffen; Affekt; Trauer, Glück; Liebe, Furcht, Ärger, Hass, Anspannung, Angst, Freude, Sorgen; emotionale Labilität; Affektverflachung<br/> Exkl.: Funktionen von Temperament und Persönlichkeit (b126); Funktionen der psychischen Energie und des Antriebs (b130)',
                  dynamic: false,
                },
                {
                  label: 'Umgang mit Stress',
                  info: 'Einfache oder komplexe und koordinierte Handlungen durchzuführen, um die psychischen Anforderungen, die erforderlich sind, um Aufgaben, die besondere Verantwortung beinhalten sowie mit Stress, Störungen und Krisensituationen verbunden sind, zu handhaben und zu kontrollieren, wie ein Fahrzeug bei dichtem Verkehr fahren oder viele Kinder betreuen.<br/> Inkl.: Mit Verantwortung umgehen; mit Stress und Krisensituationen umgehen',
                  dynamic: false,
                },
                {
                  label: 'Sein Verhalten steuern',
                  info: 'Einfach oder komplexe und koordinierte Handlungen auf einheitliche Art auszuführen als Reaktin auf neue Situationen, Personen oder Erfahrungen, wie sich in einer Bibliothek ruhig verhalten.<br/> Inkl.: Neuartiges akzeptieren, Reaktionen auf Anforderungen, Personen oder Situationen begegnen, Verlässlich handeln,Das Ausmass der Aktivität anpassen.',
                  dynamic: false,
                },
                {
                  label: 'Komplexe interpersonelle Interaktionen',
                  info: 'Die Interaktionen mit anderen in einer kontextuell und sozial angemessenen Weise aufrechtzuerhalten und zu handhaben, wie Gefühle und Impulse steuern, verbale und physische Aggressionen kontrollieren, bei sozialen Interaktionen unabhängig handeln und in Übereinstimmung mit sozialen Regeln und Konventionen handeln.<br/> Inkl.: Beziehungen eingehen und beenden; Verhaltensweisen bei Interaktionen regulieren; sozialen Regeln gemäß interagieren und sozialen Abstand wahren',
                  dynamic: false,
                },
                {
                  label: 'Formelle Beziehungen',
                  info: 'Spezielle Beziehungen in formellen Rahmen aufzunehmen und aufrecht zu erhalten, wie mit Arbeitgebern, Fachleuten oder Dienstleistungserbringer.<br/> Inkl.: Mit Autoritätspersonen, Untergebenen oder Gleichrangigen umgehen',
                  dynamic: false,
                },
              ],
            },
          },
          {
            id: '7e749515-c574-4eb1-9bcd-2ba39bf36053',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Bemerkungen / Erläuterungen / Hinweise',
            },
          },
        ],
      },
      {
        type: 'group',
        exportType: 'icf',
        label: 'Intentionale Kommunikation',
        children: [
          {
            id: '313fca41-25fe-4984-9ca9-51655cde70da',
            type: 'input',
            component: 'radio-group',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              classes: ['noicons', 'noborder'],
              fallback: false,
              options: [
                { value: 1, label: 'oberhalb Schwelle' },
                { value: 2, label: 'unterhalb Schwelle' },
              ],
            },
          },
          {
            id: '71cc981d-550c-46c0-a22a-fe6f73400f57',
            type: 'input',
            component: 'radio-matrix',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              dynamic: true,
              dynamicLabel: 'Weiteres ICF-Item hinzufügen',
              choices: [
                { value: 1, label: 'kein Problem / Ressource' },
                { value: 2, label: 'Problem leicht-mässig' },
                { value: 3, label: 'Problem erheblich-voll' },
                { value: 4, label: 'k.A., nicht spezif., nicht anwendb.' },
              ],
              value: [
                {
                  label: 'Stimm- und Sprechfunktionen',
                  info: 'Funktionen, die die Bildung verschiedener Laute während der Luftpassage durch den Kehlkopf betreffen. Sowie Funktionen der Artikulation, des Redeflusses und Sprechrhythmus und der alternativen stimmlichen Äusserungen.<br/> Inkl.: Funktionen der Stimmerzeugung und -qualität; Funktionen der Phonation, der Tonhöhe, der Lautstärke und anderer Stimmqualitäten; Funktionsstörungen wie bei Aphonie, Dysphonie, Heiserkeit, Hypernasalität, Hyponasalität.<br/> Exkl.: Kognitiv-sprachliche Funktionen (b167)',
                  dynamic: false,
                },
                {
                  label: 'Kommunizieren als Empfänger gesprochener Mitteilungen',
                  info: 'Die wörtliche und übertragene Bedeutung von gesprochenen Mitteilungen zu erfassen, wie verstehen, ob eine Aussage eine Tatsache behauptet oder ob sie eine idiomatische Wendung ist.',
                  dynamic: false,
                },
                {
                  label: 'Sprechen',
                  info: 'Wörter, Wendungen oder längere Passagen in mündlichen Mitteilungen mit wörtlicher und übertragener Bedeutung zu äußern, wie in gesprochener Sprache eine Tatsache ausdrücken oder eine Geschichte erzählen.',
                  dynamic: false,
                },
                {
                  label: 'Nonverbale Mitteilungen produzieren',
                  info: 'Gesten, Symbole und Zeichnungen zur Vermittlung von Bedeutungen einzusetzen, wie seinen Kopf schütteln, um Uneinigkeit anzuzeigen, oder ein Bild oder Diagramm zeichnen, um eine Tatsache oder eine komplexe Vorstellung zu vermitteln<br/> Inkl.: Körpergesten, Zeichen, Symbole, Zeichnungen und Fotos produzieren',
                  dynamic: false,
                },
              ],
            },
          },
          {
            id: 'eb2faf24-5b47-411d-bdec-5f9ac9f4ffe9',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Bemerkungen / Erläuterungen / Hinweise',
            },
          },
        ],
      },
      {
        type: 'group',
        exportType: 'icf',
        label: 'Bewegung, Mobilität und Motorik',
        children: [
          {
            id: '646e53cd-5217-40bd-9896-79c5d585c3cf',
            type: 'input',
            component: 'radio-group',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              classes: ['noicons', 'noborder'],
              fallback: false,
              options: [
                { value: 1, label: 'oberhalb Schwelle' },
                { value: 2, label: 'unterhalb Schwelle' },
              ],
            },
          },
          {
            id: 'bde90a3d-d9fe-44fa-b6da-172ea346618e',
            type: 'input',
            component: 'radio-matrix',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              dynamic: true,
              dynamicLabel: 'Weiteres ICF-Item hinzufügen',
              choices: [
                { value: 1, label: 'kein Problem / Ressource' },
                { value: 2, label: 'Problem leicht-mässig' },
                { value: 3, label: 'Problem erheblich-voll' },
                { value: 4, label: 'k.A., nicht spezif., nicht anwendb.' },
              ],
              value: [
                {
                  label: 'Funktionen des Muskeltonus',
                  info: 'Funktionen, die im Zusammenhang mit dem Ruhetonus der Muskeln und dem Widerstand bei passiver Bewegung stehen.<br/> Inkl.: Funktionen, die mit dem Tonus einzelner Muskeln und Muskelgruppen, Muskeln einer einzelnen Extremität, einer Körperhälfte, der unteren Körperhälfte, aller Extremitäten, des Rumpfes und aller Muskeln des Körpers verbunden sind; Funktionsstörungen wie verminderter Muskeltonus, erhöhter Muskeltonus, Spastik<br/> Exkl.: Funktionen der Muskelkraft (b730) , Funktionen der Muskelausdauer (b740)',
                  dynamic: false,
                },
                {
                  label: 'Funktionen der Kontrolle von Willkürbewegungen',
                  info: 'Funktionen, die mit der Kontrolle und Koordination von willkürlichen Bewegungen verbunden sind.<br/> Inkl.: Funktionen der Kontrolle einfacher und komplexer Willkürbewegungen, der Koordination von Willkürbewegungen, Stützfunktionen der Arme oder Beine, motorische Rechts-Links-Koordination, Auge-Hand-Koordination, Auge-Fuß-Koordination; Funktionsstörungen wie Kontroll- und Koordinationsprobleme, z.B. Dysdiadochokinese<br/> Exkl.: Funktionen der Muskelkraft (b730); Funktionen der unwillkürlichen Bewegungen (b765) , Funktionen der Bewegungsmuster beim Gehen (b770)',
                  dynamic: false,
                },
                {
                  label: 'Eine elementare Körperposition wechseln',
                  info: 'In eine und aus einer Körperposition zu gelangen und sich von einem Ort zu einem anderen zu bewegen, wie von einem Stuhl aufstehen, um sich in ein Bett zu legen, in eine und aus einer knienden oder hockenden Position gelangen.<br/> Inkl.: Seine Körperposition aus einer liegenden, knienden oder hockenden, sitzenden oder stehenden Position ändern, sich beugen und seinen Körperschwerpunkt verlagern<br/> Exkl.: Sich verlagern (d420)',
                  dynamic: false,
                },
                {
                  label: 'Feinmotorischer Handgebrauch',
                  info: 'Koordinierte Handlungen mit dem Ziel auszuführen, Gegenstände mit der Hand, den Fingern und dem Daumen aufzunehmen, zu handhaben und loszulassen, wie es für das Aufnehmen von Münzen von einem Tisch, für das Drehen einer Wählscheibe oder eines Knaufes erforderlich ist.<br/> Inkl.: aufnehmen, ergreifen, handhaben, loslassen<br/> Exkl.: Gegenstände anheben und tragen (d430)',
                  dynamic: false,
                },
              ],
            },
          },
          {
            id: 'dc831772-8892-4a88-885a-19901862160e',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Bemerkungen / Erläuterungen / Hinweise',
            },
          },
        ],
      },
      {
        type: 'group',
        exportType: 'icf',
        label: 'Ausführung der Aktivitäten des täglichen Lebens',
        children: [
          {
            id: '6914b2d4-b613-44d1-b6b6-a1eef534f861',
            type: 'input',
            component: 'radio-group',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              classes: ['noicons', 'noborder'],
              fallback: false,
              options: [
                { value: 1, label: 'oberhalb Schwelle' },
                { value: 2, label: 'unterhalb Schwelle' },
              ],
            },
          },
          {
            id: 'a21a44af-cbdf-40d4-941d-c029e036b801',
            type: 'input',
            component: 'radio-matrix',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              dynamic: true,
              dynamicLabel: 'Weiteres ICF-Item hinzufügen',
              choices: [
                { value: 1, label: 'kein Problem / Ressource' },
                { value: 2, label: 'Problem leicht-mässig' },
                { value: 3, label: 'Problem erheblich-voll' },
                { value: 4, label: 'k.A., nicht spezif., nicht anwendb.' },
              ],
              value: [
                {
                  label: 'Die tägliche Routine durchführen',
                  info: 'Einfache und komplexe und koordinierte Handlungen auszuführen, um die Anforderungen der alltäglichen Prozeduren oder Pflichten zu planen, zu handhaben und zu bewältigen, wie Zeit einplanen und den Tagesplan für die verschiedenen Aktivitäten aufstellen.<br/> Inkl.: Die tägliche Routine handhaben und zu Ende bringen; das eigene Aktivitätsniveau handhaben<br/> Exkl.: Mehrfachaufgaben übernehmen (d220)',
                  dynamic: false,
                },
                {
                  label: 'Toilette benutzen',
                  info: 'Die Beseitigung menschlicher Ausscheidungen (Menstruationssekrete, Urin, Stuhl) zu planen und durchzuführen sowie sich anschließend zu reinigen.<br/> Inkl.: Die Belange der Blasen- und Darmentleerung sowie der Menstruation regulieren<br/> Exkl.: Sich waschen (d510); Seine Körperteile pflegen (d520)',
                  dynamic: false,
                },
                {
                  label: 'Sich kleiden',
                  info: 'Die koordinierten Handlungen und Aufgaben durchzuführen, welche das An- und Ausziehen von Kleidung und Schuhwerk in Abfolge und entsprechend den sozialen und klimatischen Bedingungen betreffen, wie Hemden, Röcke, Blusen, Hosen, Unterwäsche, Saris, Kimonos, Strumpfhosen, Hüte, Handschuhe, Mäntel, Schuhe, Stiefel, Sandalen oder Slipper anziehen, ordnen und ausziehen.<br/> Inkl.: Kleidung und Schuhwerk an- und ausziehen sowie geeignete Kleidung auswählen',
                  dynamic: false,
                },
                {
                  label: 'Essen',
                  info: 'Die koordinierten Handlungen und Aufgaben durchzuführen, die das Essen servierter Speisen betreffen, sie zum Mund zu führen und auf kulturell akzeptierte Weise zu verzehren, Nahrungsmittel in Stücke zu schneiden oder zu brechen, Flaschen und Dosen zu öffnen, Essbesteck zu benutzen, Mahlzeiten einnehmen, zu schlemmen oder zu speisen.<br/> Exkl.: Trinken (d560)',
                  dynamic: false,
                },
                {
                  label: 'Auf eigene Sicherheit achten',
                  info: 'Risiken zu vermeiden, die zu körperlichen Verletzungen oder Leid führen können, riskante Situationen zu vermeiden, wie Missbrauch von Feuer oder Gefährdungen im Strassenverkehr.',
                  dynamic: false,
                },
              ],
            },
          },
          {
            id: '2fd3fa01-c63a-4a98-92a1-7c90e748200a',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Bemerkungen / Erläuterungen / Hinweise',
            },
          },
        ],
      },
      {
        type: 'group',
        exportType: 'icf',
        label: '(Vor-)Schulische Fertigkeiten',
        tooltip: 'Die Items Sich Fertigkeiten aneignen, Lesen, Schreiben, Rechnen sind in einem Abschnitt „(Vor-)Schulische Fertigkeiten“ zusammengefasst, der kein Indikationsbereich ist.',
        children: [
          {
            type: 'spacer',
            component: 'spacer',
          },
          {
            id: '918611b7-b44d-4436-a261-1e18ad8a0749',
            type: 'input',
            component: 'radio-matrix',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              dynamic: true,
              dynamicLabel: 'Weiteres ICF-Item hinzufügen',
              choices: [
                { value: 1, label: 'kein Problem / Ressource' },
                { value: 2, label: 'Problem leicht-mässig' },
                { value: 3, label: 'Problem erheblich-voll' },
                { value: 4, label: 'k.A., nicht spezif., nicht anwendb.' },
              ],
              value: [
                {
                  label: 'Sich Fertigkeiten aneignen',
                  info: 'Elementare und komplexe Fähigkeiten für integrierte Mengen von Handlungen und Aufgaben zu entwickeln, um die Aneignung einer Fertigkeit anzugehen und zu Ende zu bringen, wie Werkzeuge handhaben oder Spiele wie Schach spielen.<br/> Inkl.: Sich elementare und komplexe Fähigkeiten aneignen',
                  dynamic: false,
                },
                {
                  label: 'Lesen',
                  info: 'Aktivitäten im Zusammenhang mit der Erfassung und Interpretation von Texten (z.B. Bücher, Anweisungen oder Zeitungen - auch in Braille) durchzuführen, um allgemeines Wissen oder besondere Informationen zu erlangen.<br/> Exkl.: Lesen lernen (d140)',
                  dynamic: false,
                },
                {
                  label: 'Schreiben',
                  info: 'Symbole oder Sprache zu verwenden oder zu produzieren, um Informationen zu vermitteln, wie schriftliche Aufzeichnungen von Ereignissen oder Ideen produzieren oder einen Brief entwerfen.<br/> Exkl.: Schreiben lernen (d145)',
                  dynamic: false,
                },
                {
                  label: 'Rechnen',
                  info: 'Berechnungen unter Anwendung mathematischer Prinzipien durchzuführen, um in Worten beschriebene Probleme zu lösen und die Ergebnisse zu produzieren oder darzustellen, wie die Summe aus drei Zahlen berechnen oder das Ergebnis der Division einer Zahl durch eine andere finden.<br/> Exkl.: Rechnen lernen (d150)',
                  dynamic: false,
                },
              ],
            },
          },
          {
            id: '542bf8ed-a630-4051-94b9-5ea7cca089ed',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Bemerkungen / Erläuterungen / Hinweise',
            },
          },
        ],
      },
      {
        type: 'group',
        exportType: 'icf',
        label: 'Weitere ICF-Items',
        children: [
          {
            type: 'spacer',
            component: 'spacer',
          },
          {
            id: '1875526a-6216-46d3-a6c6-542d96534e42',
            type: 'input',
            component: 'radio-matrix',
            for_state: false,
            for_report: false,
            required: false,
            props: {
              dynamic: true,
              dynamicLabel: 'Weiteres ICF-Item hinzufügen',
              choices: [
                { value: 1, label: 'kein Problem / Ressource' },
                { value: 2, label: 'Problem leicht-mässig' },
                { value: 3, label: 'Problem erheblich-voll' },
                { value: 4, label: 'k.A., nicht spezif., nicht anwendb.' },
              ],
              value: [],
            },
          },
          {
            id: '57030b49-53a6-48b1-a712-96e59a284d1d',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Bemerkungen/ Erläuterungen / Hinweise auf besondere Stärken',
            },
          },
        ],
      },
      {
        type: 'group',
        label: 'Gesamteinschätzung',
        children: [
          {
            type: 'spacer',
            component: 'spacer',
          },
          {
            id: '9d7cb668-0e4d-40c7-933c-11a2e11d2905',
            type: 'input',
            component: 'radio-matrix',
            for_state: true,
            for_report: false,
            required: false,
            props: {
              choices: [
                { value: 1, label: 'nicht eingeschränkt' },
                { value: 2, label: 'leicht-mässig eingeschränkt' },
                { value: 3, label: 'erheblich-voll eingeschränkt' },
              ],
              value: [
                {
                  label: 'Gesamteinschätzung der Funktionsfähigkeit bezüglich Körperfunktionen, Aktivitäten und Partizipation',
                  dynamic: false,
                },
              ],
            },
          },
          {
            id: '2be86efb-8c36-4cf7-9cdd-2e65d72910ba',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: false,
            required: false,
            props: {
              label: 'Qualifizierende Begründung',
            },
          },
        ],
      },
    ],
  },
  {
    type: 'section',
    label: 'ICD/DSM-Erfassung',
    heading: 'Kind / Jugendlicher: ICD/DSM-Erfassung',
    children: [
      {
        type: 'group',
        label: 'Diagnosen',
        children: [
          {
            id: 'd450638b-5a18-412b-a5f9-57a9c099ce4f',
            type: 'input',
            component: 'diagnosis',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              diagnoses: DIAGNOSES,
              dynamic: true,
              dynamicLabel: 'Weitere Diagnosen hinzufügen',
              types: true,
            },
          },
        ],
      },
      {
        type: 'group',
        label: 'Verdachtsdiagnosen',
        export: {
          label: ' ',
        },
        children: [
          {
            id: '5e86b5dd-fd20-4c9d-aec8-c45dd78ed89d',
            type: 'input',
            component: 'diagnosis',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              diagnoses: DIAGNOSES,
              dynamic: true,
              dynamicLabel: 'Weitere Verdachtsdiagnose hinzufügen',
            },
          },
        ],
      },
      {
        type: 'group',
        children: [
          {
            id: 'd7103f2b-083e-4a6d-9517-fcb63cb703bb',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            exportStyle: 'fullwidth-labeled',
            props: {
              label: 'Bemerkungen zu ICD/DSM-Erfassung',
            },
          },
        ],
      },
    ],
  },
  {
    type: 'section',
    label: 'Entwicklungs- & Bildungsziele',
    heading: 'Entwicklungs- und Bildungsziele',
    tooltip: 'Für eine Sonderschulung muss mindestens in einem Entwicklungsbereich eine Individualisierung vorliegen und es muss mindestens ein Förderschwerpunkt bezeichnet werden. Für die Einschätzung der Entwicklungsbereiche ist nebst der Orientierung am Lehrplan eine ganzheitliche, entwicklungspsychologische Betrachtungsweise angebracht. Zum Zeitpunkt der Abklärung ist ein Entwicklungsbereich oft noch nicht individualisiert und es bestehen noch keine entsprechenden Anpassungen. Die Einschätzung des aktuellen Stands bezieht sich auf eine markante Diskrepanz, die eine Individualisierung notwendig macht. Unter Hinweise für Förderplanung können Bemerkungen festgehalten werden.',
    children: [
      {
        type: 'group',
        exportType: 'radio-matrix-advanced',
        children: [
          {
            id: '4858b2b0-412e-4df1-8647-bd3b40619fda',
            type: 'input',
            component: 'radio-matrix-advanced',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              choices: [
                {
                  type: 'radiogroup',
                  label: 'Aktuell',
                  for_state: true,
                  choices: [
                    { value: 1, label: 'alters-/ lehrplangemäss' },
                    { value: 2, label: 'individualisiert' },
                  ],
                },
                {
                  type: 'radiogroup',
                  label: 'Anvisiert (1-2 Jahre)',
                  for_state: true,
                  choices: [
                    { value: 1, label: 'alters-/ lehrplangemäss' },
                    { value: 2, label: 'individualisiert' },
                  ],
                },
                {
                  type: 'checkbox',
                  choices: [
                    { value: 'schwerpunkt', label: 'Schwerpunkt für Förderung' },
                  ],
                },
              ],
              value: [
                {
                  label: 'Lernen und Wissensanwendung',
                  dynamic: false,
                },
                {
                  label: 'Allg. Aufgaben und Anforderungen',
                  dynamic: false,
                },
                {
                  label: 'Kommunikation',
                  dynamic: false,
                },
                {
                  label: 'Mobilität',
                  dynamic: false,
                },
                {
                  label: 'Für sich selbst sorgen',
                  dynamic: false,
                },
                {
                  label: 'Interaktionen & Beziehungen',
                  dynamic: false,
                },
              ],
            },
          },
          {
            id: '0ea7cb67-ce4d-4b06-a450-5f008b1a3874',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Hinweise für die Förderplanung / Bemerkungen',
            },
          },
        ],
      },
    ],
  },
  {
    type: 'section',
    label: 'Zusammenfassung',
    heading: 'Zusammenfassung',
    children: [
      {
        type: 'group',
        label: 'Frühbereich',
        children: [
          {
            id: '5b19af3d-7193-4a56-910a-d6c4664d4c8a',
            type: 'input',
            component: 'radio-group',
            for_state: true,
            for_report: false,
            required: true,
            props: {
              label: 'Zusammenfassende Einschätzung in Bezug auf die Entwicklung im familiären Umfeld / auf Interventionen im Frühbereich',
              options: [
                { value: 1, label: 'gemäss Lebensalter gefördert' },
                { value: 2, label: 'teilweise nach nicht altersentsprechenden Zielen gefördert' },
                { value: 3, label: 'durchgehend nach nicht altersentsprechenden Zielen gefördert' },
              ],
            },
          },
        ],
      },
      {
        type: 'group',
        label: 'Schulbereich',
        children: [
          {
            id: '5b19af3d-7193-4a56-910a-d6c4664d4c8a',
            type: 'input',
            component: 'radio-group',
            for_state: true,
            for_report: false,
            required: true,
            props: {
              label: 'Zusammenfassende Einschätzung in Bezug auf den Förderbedarf / den Lehrplanstatus',
              tooltip: '2: Kriterium: Der Unterricht ist in ein bis zwei Fächern nicht auf das Erreichen der Mindestanforderungen dem Lehrplans ausgerichtet. 3: Kriterium: Der Unterricht ist in drei oder mehr Fächern nicht auf das Erreichen der Mindestanforderungen des Lehrplans ausgerichtet. (Als Fächer gelten Schulsprache , Fremdsprachen, Mathematik und Naturwissenschaften.)',
              options: [
                { value: 4, label: 'lehrplangebundener Unterricht' },
                { value: 5, label: 'Unterricht mit teilweise angepassten Lernzielen' },
                { value: 6, label: 'Unterricht mit mehrheitlich angepassten Lernzielen' },
              ],
            },
          },
        ],
      },
    ],
  },
  {
    type: 'section',
    label: 'Bedarfseinschätzung',
    heading: 'Bedarfseinschätzung',
    children: [
      {
        type: 'group',
        label: 'Vom SAV abhängige Massnahmen',
        children: [
          {
            id: 'af232f33-a8ca-4086-9b0c-f3a786da73bd',
            type: 'input',
            component: 'radio-group',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              label: 'Sonderpädagogische Massnahmen',
              tooltip: 'Bedarf = IF oder Heilpädagogische Früherziehung.<br/> Verstärkter Bedarf = ISR/ISS, Tagessonderschule oder Schulheim.',
              options: [
                { value: 1, label: 'kein Bedarf' },
                { value: 2, label: 'Bedarf' },
                { value: 3, label: 'verstärkter Bedarf' },
              ],
            },
          },
          {
            id: '3bdbe272-fa96-4a45-8c36-664f1522fc76',
            type: 'input',
            component: 'radio-group',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              label: 'Pädagogisch-therapeutische Massnahmen',
              tooltip: 'Bedarf =  Massnahmen wie Logopädie, PMT, schulisch indizierte Psychotherapie, Audiopädagogik, Low Vision.',
              options: [
                { value: 1, label: 'kein Bedarf' },
                { value: 2, label: 'Bedarf' },
              ],
            },
          },
          {
            id: '58d5771e-a4b6-45e5-954d-83313e6cf46f',
            type: 'input',
            component: 'radio-group',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              label: 'Beratung und Unterstützung / Assistenz',
              tooltip: 'Hier können behinderungsspezifische B+U oder eine persönliche Assistenz in der Klasse aufgeführt werden (z.B. sehbehindertenspezifische Beratung, Gebärdensprachdolmetscher, persönliche Assistenz für alltägliche Verrichtungen).',
              options: [
                { value: 1, label: 'kein Bedarf' },
                { value: 2, label: 'Bedarf' },
              ],
            },
          },
          {
            id: '89ce49c5-2702-48fa-9ae8-1cf75a00cc10',
            type: 'input',
            component: 'radio-group',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              label: 'Betreuung',
              tooltip: 'Bedarf = Tagesstruktur (z.B. Hort), sozialpädagogische Betreuung (z.B. an einer Tagessonderschule)<br/> Verstärkter Bedarf = Sonderschulheim, Internatsstruktur, Pflegefamilie, Wohnheim/Gruppe<br/> Bei ausserfamiliärer Platzierung muss unter Bemerkungen genauer ausgeführt werden, welche Form gemeint ist.',
              options: [
                { value: 1, label: 'kein Bedarf' },
                { value: 2, label: 'Bedarf' },
                { value: 3, label: 'verstärkter Bedarf' },
              ],
            },
          },
          {
            id: 'fb8478f8-90b4-4a75-b4e0-054824860c88',
            type: 'input',
            component: 'radio-group',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              label: 'Transport',
              options: [
                { value: 1, label: 'kein Bedarf' },
                { value: 2, label: 'Bedarf' },
              ],
            },
          },
          {
            id: 'c0494421-a843-44c1-9792-ea40abe8f675',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: true,
            props: {
              label: 'Bemerkungen',
            },
          },
        ],
      },
      {
        type: 'group',
        label: 'Vom SAV unabhängige Massnahmen',
        children: [
          {
            id: '20fe05b5-f43d-4ce5-86a7-db2496b5608d',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Hinweis auf Bedarf an therapeutischen / medizinischen / klinischen Massnahmen',
              tooltip: 'Z.B. medizinische Massnahmen wie Ergotherapie, Physiotherapie, Psychotherapie, Psychiatrie-Spitex.',
            },
          },
          {
            id: '4884c70d-5d54-4154-8653-b5b6d4ce46d8',
            type: 'input',
            component: 'textarea',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              label: 'Hinweis auf Bedarf an Unterstützung des derzeitigen professionellen Umfelds',
            },
          },
          {
            id: '73fdebb5-7730-4fad-a80e-7418b452f90f',
            type: 'input',
            component: 'textarea',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              label: 'Hinweis auf Bedarf an Unterstützung des familiären Umfelds',
              tooltip: 'Z.B. Erziehungsberatung, sozial-pädagogische Familienbegleitung',
            },
          },
          {
            id: 'aad00add-4ebf-46ea-96f7-ea21232d9e82',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Erläuterung und Bemerkungen zu abweichenden Einschätzungen',
              tooltip: 'namentlich bei abweichenden Einschätzungen der Erziehungsberrechtigten, des Kindes/Jugendlichen und/oder von Personen aus dem derzeitigen professionellen Umfeld',
            },
          },
        ],
      },
      {
        type: 'group',
        label: 'Zusammenfassende Beurteilung',
        children: [
          {
            id: 'fc8b675b-8ddb-4b87-a9ba-898281ee46d1',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: true,
            exportStyle: 'fullwidth',
            props: {
              label: 'Zusammenfassende Beurteilung',
              export: { default: '' },
              tooltip: 'Hier nach der Basisabklärung und auf Grundlage des Bedarfs eine gewichtende und interpretierende Konklusion im Hinblick auf die Empfehlung schreiben. Nicht nur Wiederholung. Mindestens zum Kind/Jugendlichen, zum Kontext, zu den Zielen und dem Bedarf je einen Satz.',
            },
          },
        ],
      },
    ],
  },
  {
    type: 'section',
    label: 'Empfehlung',
    heading: 'Empfehlung / Antrag Hauptförderort und Massnahmen',
    children: [
      {
        type: 'group',
        children: [
          {
            id: '7dfdbd93-a91c-4ce3-b31a-5f21ccc02ad3',
            type: 'input',
            component: 'select',
            for_state: true,
            for_report: true,
            required: false,
            props: {
              label: 'Art der Beschulung',
              options: [
                { value: 1, label: 'Integrierte Sonderschulung in Verantwortung der Regelschule (ISR)' },
                { value: 2, label: 'Integrierte Sonderschulung in Verantwortung der Sonderschule (ISS)' },
                { value: 3, label: 'Tagessonderschulung' },
                { value: 4, label: 'Heimsonderschulung' },
                { value: 5, label: 'Regelschulung' },
                { value: 6, label: 'andere Beschulung' },
                { value: 7, label: 'keine (z.B. Rückstellung)' },
              ],
            },
          },
          {
            id: '158c45f6-d9d2-496a-9b6a-47207d786f5c',
            type: 'input',
            component: 'select',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              label: 'Typus Sonderschulung',
              tooltip: 'Sonderschultyp A: Beeinträchtigungen in den Bereichen Verhalten, Lernen oder Sprache<br/> Sonderschultyp B1: Körper-, Sinnes- oder Mehrfachbeeinträchtigungen ohne kognitive Beeinträchtigung<br/> Sonderschultyp B2: Körper-, Sinnes- oder Mehrfachbeeinträchtigungen mit kognitiver Beeinträchtigung<br/> Sonderschultyp C: kognitive Beeinträchtigungen',
              options: [
                { value: 'a', label: 'Sonderschultyp A' },
                { value: 'b1', label: 'Sonderschultyp B1' },
                { value: 'b2', label: 'Sonderschultyp B2' },
                { value: 'c', label: 'Sonderschultyp C' },
                { value: 'k', label: 'Keine' },
              ],
            },
          },
          {
            id: 'a022b9f1-190b-4df3-b70c-9777832d4dba',
            type: 'input',
            component: 'textarea',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              label: 'Massnahmen am Hauptförderort',
              tooltip: 'Alle empfohlenen schulischen Massnahmen, wie IF, DaZ,  angepasste Lernziele, Nachteilsausgleich, Therapien, Beratung, Assistenz usw.',
            },
          },
          {
            id: '3eb22885-4797-43cf-8c4a-dace5ccf8806',
            type: 'input',
            component: 'textinput',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Sonderschuleinrichtung',
            },
          },
          {
            id: '317bbfd9-1bf8-4b25-899f-7da5a3d8a467',
            type: 'input',
            component: 'textarea',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              label: 'Massnahmen, die nicht am Hauptförderort angeboten werden sollen',
            },
          },
          {
            id: 'dfac88f4-37e6-4544-967d-f76d889475e6',
            type: 'input',
            component: 'textarea',
            for_state: true,
            for_report: true,
            required: true,
            props: {
              label: 'Massnahmen, die dem Umfeld des Kindes / des/der Jugendlichen angeboten werden sollen',
              tooltip: 'z.B. erzieherische Hilfen wie sozialpädagogische Familienbegleitung',
            },
          },
          {
            id: '435121f8-17ed-43a4-9503-ee8169ce52a6',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: true,
            props: {
              label: 'Mögliche Alternativen zur Empfehlung Hauptförderort und Massnahmen',
            },
          },
          {
            id: 'b5b2321a-c6fa-4380-ad56-aa27a410b4b6',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: true,
            props: {
              label: 'Transport',
            },
          },
          {
            id: '09b97e27-2e0e-480c-8421-7e487c7b06f9',
            type: 'input',
            component: 'radio-group',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Einverständnis Erziehungsberechtigte',
              tooltip: 'Rechtlich relevant ist das Einverständnis der Erziehungsberechtigten.',
              options: [
                { value: 'yes', label: 'Ja' },
                { value: 'no', label: 'Nein' },
                { value: 'na', label: 'keine Angabe' },
              ],
            },
          },
          {
            id: 'da81df34-0e3b-4bdc-880d-8b81dba214c3',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: false,
            required: false,
            props: {
              label: 'Bemerkungen (namentlich bei abweichenden Einschätzungen der Erziehungsberechtigen, des Kindes/Jugendlichen und/oder von Personen aus dem derzeitigen professionellen Umfeld)',
            },
          },
          {
            id: '4aff6b99-1b01-45f8-96e8-ff624918cfdb',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: true,
            props: {
              label: 'Bemerkungen und Vorgehen',
            },
          },
          {
            id: 'f7af60c1-3312-4810-ad0d-3cbb19ac1923',
            type: 'input',
            component: 'textarea',
            for_state: true,
            for_report: false,
            required: false,
            props: {
              label: 'Von der Schulpflege beschlossene Massnahmen. (Nach Gutsprache durch fallführende Person auszufüllen)',
              tooltip: 'Nur ausfüllen, wenn SPD davon Kenntnis hat, ansonsten ist es "--".',
              value: '--',
            },
          },
          {
            id: '24b0811b-e211-45a0-9b62-0322a94dc13c',
            type: 'input',
            component: 'select',
            for_state: true,
            for_report: false,
            required: false,
            props: {
              label: 'Kategorisierung der definitiven Massnahmen',
              tooltip: 'Nur ausfüllen, wenn SPD davon Kenntnis hat, ansonsten ist es ein Leerfeld.',
              options: [
                { value: 1, label: 'Massnahmen wie empfohlen' },
                { value: 2, label: 'Andere Massnahmen für eine grössere Wohnortnähe' },
                { value: 3, label: 'Andere Massnahmen aus anderen Gründen' },
                { value: 4, label: 'Andere Massnahmen aus Platzmangel' },
                { value: 6, label: 'Definitive Massnahme noch nicht bekannt' },
                { value: 5, label: 'Keine' },
              ],
            },
          },
          {
            id: '5280693d-48c6-4c9e-af40-a23cfec72d67',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: true,
            required: false,
            props: {
              label: 'Verteiler',
              tooltip: 'i.d.R. stets Eltern und Schulpflege (gemäss Regelung in der jeweiligen Gemeinde auch Fachstelle Sonderpädagogik, Schulleitung).<br/> Namen und Funktionen der Adressaten nennen.<br/> Beistände bei Beistandschaft mit schulischem Auftrag.<br/> Schulleitungen zukünftiger Sonderschulen sollen einen Bericht erhalten, Eltern informieren.',
              value: 'Schulpflege / Eltern\nDie Schulleitung der durchführenden Stelle erhält den SAV-Bericht mit dem Entscheid der Schulpflege oder nach Absprache der Beteiligten',
            },
          },
        ],
      },
    ],
  },
  {
    type: 'section',
    label: 'Anhang',
    heading: 'Anhang',
    noProgress: true,
    children: [
      {
        type: 'group',
        label: 'Fachbericht 1',
        children: [
          {
            id: 'a991b0bf-de55-4a6e-8971-91c18b7cb789',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: false,
            required: false,
            props: {
              label: 'Verantwortliche/r Person bzw. Dienst (Name, Vorname, berufliche Bezeichnung)',
            },
          },
          {
            id: 'f9446a1f-52f9-45ee-8364-5771342c79a1',
            type: 'input',
            component: 'datepicker',
            for_state: false,
            for_report: false,
            required: false,
            props: {
              label: 'Erstellt am',
            },
          },
          {
            id: 'ad72bc8a-5348-4bd7-a55b-0a482cf19fc7',
            type: 'input',
            component: 'select',
            for_state: false,
            for_report: false,
            required: false,
            props: {
              label: 'Fachbericht liegt bei der Abklärungsstelle vor',
              options: [
                { value: true, label: 'Ja' },
                { value: false, label: 'Nein' },
              ],
            },
          },
          {
            id: 'fe59f46b-950d-4072-a32f-df9207905ece',
            type: 'input',
            component: 'select',
            for_state: false,
            for_report: false,
            required: false,
            props: {
              label: 'Fachbericht ist dem vorliegenden Bericht beigelegt',
              options: [
                { value: true, label: 'Ja' },
                { value: false, label: 'Nein' },
              ],
            },
          },
        ],
      },
      {
        type: 'group',
        label: 'Fachbericht 2',
        children: [
          {
            id: '33f98eec-91c5-43da-a92c-2f0cda1ff756',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: false,
            required: false,
            props: {
              label: 'Verantwortliche/r Person bzw. Dienst (Name, Vorname, berufliche Bezeichnung)',
            },
          },
          {
            id: '47eae61a-9aa5-45a3-a8bb-282e70eb6090',
            type: 'input',
            component: 'datepicker',
            for_state: false,
            for_report: false,
            required: false,
            props: {
              label: 'Erstellt am',
            },
          },
          {
            id: 'cd3e8faf-3236-4fa9-b98d-1713c637c691',
            type: 'input',
            component: 'select',
            for_state: false,
            for_report: false,
            required: false,
            props: {
              label: 'Fachbericht liegt bei der Abklärungsstelle vor',
              options: [
                { value: true, label: 'Ja' },
                { value: false, label: 'Nein' },
              ],
            },
          },
          {
            id: 'a9aa0c4f-7ce0-4a93-b65a-5c833c73ceff',
            type: 'input',
            component: 'select',
            for_state: false,
            for_report: false,
            required: false,
            props: {
              label: 'Fachbericht ist dem vorliegenden Bericht beigelegt',
              options: [
                { value: true, label: 'Ja' },
                { value: false, label: 'Nein' },
              ],
            },
          },
        ],
      },
      {
        type: 'group',
        label: 'Fachbericht 3',
        children: [
          {
            id: 'bb9fbb36-7a89-4a71-959e-156d0cd4aab1',
            type: 'input',
            component: 'textarea',
            for_state: false,
            for_report: false,
            required: false,
            props: {
              label: 'Verantwortliche/r Person bzw. Dienst (Name, Vorname, berufliche Bezeichnung)',
            },
          },
          {
            id: '977aa590-db5e-4918-a264-ea6ffdde78a6',
            type: 'input',
            component: 'datepicker',
            for_state: false,
            for_report: false,
            required: false,
            props: {
              label: 'Erstellt am',
            },
          },
          {
            id: 'dfd56828-461a-441a-a51a-118716ea9ce8',
            type: 'input',
            component: 'select',
            for_state: false,
            for_report: false,
            required: false,
            props: {
              label: 'Fachbericht liegt bei der Abklärungsstelle vor',
              options: [
                { value: true, label: 'Ja' },
                { value: false, label: 'Nein' },
              ],
            },
          },
          {
            id: '8ca34a14-f87c-4db5-82f2-44f2422e1535',
            type: 'input',
            component: 'select',
            for_state: false,
            for_report: false,
            required: false,
            props: {
              label: 'Fachbericht ist dem vorliegenden Bericht beigelegt',
              options: [
                { value: true, label: 'Ja' },
                { value: false, label: 'Nein' },
              ],
            },
          },
        ],
      },
    ],
  },
];
